module.exports = __webpack_public_path__ + "assets/hongbao-bg-41458319.png";